import { mapEnumToOptions } from '@abp/ng.core';

export enum PublishType {
  Publish = 1,
  OnlyFollowers = 2,
  NotPublished = 3,
}

export const publishTypeOptions = mapEnumToOptions(PublishType);
